export default __webpack_public_path__ + "static/media/Screenshot (500).2dc29883.png";